export enum ReferencePlacement {
	Accounting = "Accounting",
	CloudSolution = "CloudSolution",
	CustomDevelopment = "CustomDevelopment",
	DigitalizationAutomation = "DigitalizationAutomation",
	Ecommerce = "Ecommerce",
	Gastro = "Gastro",
	Hr = "Hr",
	ItRental = "ItRental",
	MobileApps = "MobileApps",
	ProjectRescue = "ProjectRescue",
	ItServices = "ItServices",
	Transport = "Transport",
	Production = "Production",
	WebsEshops = "WebsEshops",
}
